import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { Anchor, ButtonSubmit, Form } from '@anytag/shared-atoms';
import { PasswordField, TextField } from '@anytag/shared-molecules';
import { SignInFormKeys, SignInFormValues } from './types';

export const Template = () => {
  const {
    formState: { isSubmitting }
  } = useFormContext<SignInFormValues>();
  const { t } = useTranslation();

  return (
    <Form.Body className="rounded-sm px-10 pt-12 pb-6 shadow-none">
      <h1 className="text-center text-xl leading-[100%]">{t('Password.Sign In')}</h1>

      <p className="mt-4 mb-2 text-center text-base leading-[140%]">
        {t('Password.Please Sign In')}
        <br />
        {t('Password.Email And Password')}
      </p>

      <TextField<SignInFormKeys> name="email" title={t('TextForm.Email')} placeholder="your@email.com" />

      <PasswordField<SignInFormKeys>
        name="password"
        title={t('Password.Password')}
        placeholder={t<string>('Password.Your Password')}
      />

      <ButtonSubmit size="md" loading={isSubmitting} title={t('Button.Sign In')} className="mt-4 w-full" />

      <Anchor variant="blue" className="mt-6 text-center text-sm" to="/password_forgot">
        {t('Password.Forgot Password')}
      </Anchor>

      <p className="mt-17.5 text-[11px] leading-[140%] text-tertiary">
        <Trans
          i18nKey="SignInConfirmation"
          components={{
            a1: <Anchor variant="blue" className="inline" to="/privacy" />,
            a2: <Anchor variant="blue" className="inline" to="/terms-combined" />
          }}
        />
      </p>
    </Form.Body>
  );
};
